import { FieldError } from 'react-hook-form';

export const formValidators = {
  namespace: {
    noSpecialChars: (value: string) => /^[a-zA-Z0-9]+$/.test(value),
    lowerCase: (value: string) => !/[^a-z0-9]/g.test(value),
  },
  website: {
    validURL: (value?: string | null) =>
      !value ||
      /^http(s)?:\/\/[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gm.test(value),
  },
  email: {
    validEmail: (value: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value),
  },
};

export const getErrorMessage = (error?: FieldError): string => {
  if (!error) return '';

  switch (error.type) {
    case 'required':
      return 'Required';
    case 'lowerCase':
      return 'Must be lower case';
    case 'noSpecialChars':
      return 'No special characters or whitespace allowed';
    case 'validURL':
      return 'Must be a valid URL with a protocol: ( http(s):// )';
    case 'companyUnique':
      return 'Company must be unique';
    case 'validEmail':
      return 'Must be a valid email';
    case 'manual':
      return error.message || 'Invalid';
    default:
      return 'Invalid';
  }
};
